import React from 'react';
import { Flex, Text, useColorModeValue } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import CommonTable from 'components/commonTable/CommonTable';
import moment from 'moment';
import { rentalStatusMap } from 'utils/StaticData';
import PropTypes from 'prop-types';

const ActivatedOrderListTable = ({ tableData, isLoading }) => {
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const columnHelper = createColumnHelper();
  const columns = [
    columnHelper.accessor((row) => row?.intentId, {
      id: 'intentId',
      header: () => (
        <Text
          justifyContent="space-between"
          align="left"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          whiteSpace="nowrap"
        >
          Order Id
        </Text>
      ),
      cell: (info) => (
        <Flex align="center">
          <Text
            color={textColor}
            fontSize="sm"
            fontWeight="600"
            align="left"
            whiteSpace="nowrap"
            overflow={'hidden'}
            textOverflow={'ellipsis'}
          >
            {info.getValue()}
          </Text>
        </Flex>
      ),
    }),
    columnHelper.accessor((row) => row?.rentalStatus, {
      id: 'rentalStatus',
      header: () => (
        <Text
          align="left"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          whiteSpace="nowrap"
        >
          Rental Status
        </Text>
      ),
      cell: (info) => {
        const statusValue = info.getValue();
        const statusText = rentalStatusMap[statusValue] || 'N/A';

        return (
          <Text
            color={textColor}
            fontSize="sm"
            fontWeight="600"
            align="left"
            whiteSpace="nowrap"
            overflow={'hidden'}
            textOverflow={'ellipsis'}
          >
            {statusText}
          </Text>
        );
      },
    }),
    columnHelper.accessor((row) => row?.paymentStatus, {
      id: 'paymentStatus',
      header: () => (
        <Text
          align="left"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          whiteSpace="nowrap"
        >
          Payment Status
        </Text>
      ),
      cell: (info) => (
        <Text
          color={info.getValue() === 1 ? 'green.500' : 'red.500'}
          fontSize="sm"
          fontWeight="600"
          align="left"
          whiteSpace="nowrap"
          overflow={'hidden'}
          textOverflow={'ellipsis'}
        >
          {info.getValue() === 1 ? 'Paid' : 'Unpaid'}
        </Text>
      ),
    }),
    columnHelper.accessor((row) => row?.rentTime, {
      id: 'rentTime',
      header: () => (
        <Text
          align="left"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          whiteSpace="nowrap"
        >
          Rent Time
        </Text>
      ),
      cell: (info) => {
        const rentTime = info.getValue();
        const formattedDateTime = moment
          .parseZone(rentTime)
          .format('DD-MM-YYYY HH:mm:ss');
        return (
          <Text
            color={textColor}
            fontSize="sm"
            fontWeight="600"
            align="left"
            whiteSpace="nowrap"
            overflow={'hidden'}
            textOverflow={'ellipsis'}
          >
            {formattedDateTime}
          </Text>
        );
      },
    }),
    columnHelper.accessor((row) => row?.rentalMerchant, {
      id: 'rentalMerchant',
      header: () => (
        <Text
          align="left"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          whiteSpace="nowrap"
        >
          Rental Merchant
        </Text>
      ),
      cell: (info) => (
        <Flex align="center">
          <Text
            color={textColor}
            fontSize="sm"
            fontWeight="600"
            align="left"
            whiteSpace="nowrap"
            overflow={'hidden'}
            textOverflow={'ellipsis'}
          >
            {info.getValue()}
          </Text>
        </Flex>
      ),
    }),
    columnHelper.accessor((row) => row?.rentalStationId, {
      id: 'rentalStationId',
      header: () => (
        <Text
          align="left"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          whiteSpace="nowrap"
        >
          Rental Stations
        </Text>
      ),
      cell: (info) => (
        <Text
          color={textColor}
          fontSize="sm"
          fontWeight="600"
          align="left"
          whiteSpace="nowrap"
          overflow={'hidden'}
          textOverflow={'ellipsis'}
        >
          {info.getValue()}
        </Text>
      ),
    }),
  ];

  return (
    <>
      <CommonTable
        columns={columns}
        data={tableData}
        isLoading={isLoading}
        dynamicWidth={{
          intentId: '200px',
          rentalStatus: '100px',
          paymentStatus: '100px',
          rentTime: '200px',
          rentalMerchant: '200px',
          rentalStationId: '100px',
        }}
      />
    </>
  );
};

ActivatedOrderListTable.propTypes = {
  tableData: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default ActivatedOrderListTable;
